<script setup lang="ts">
import { defineProps, ref } from 'vue';
const props = defineProps<{
    label: string,
    icon?: string,
    styleType?: string,
    spinner?:boolean,
    onclick?: () => void,
}>()

export type ActionButtonProps = {
    label: string, // display text
    icon: string, // action to perform
    styleType: string, // display style
    spinner: boolean, // show spinner
    onclick: () => void | boolean, // callback
}

const clicked = ref(false)

let classList: string[] = []
if (props.styleType === "white"){
    classList = ["cursor-pointer", "font-bold", "text-center", "btn", "rounded-2.4xl", "xl:rounded-3xl", "text-mono-ns-200", "bg-mono-white", "hover:bg-mono-ps-100", "min-w-fit", "w-full", "relative"]
}else if (props.styleType === "primary"){
    classList = ["cursor-pointer", "font-bold", "text-center", "btn", "cta-g", "rounded-2.4xl", "xl:rounded-3xl", "text-mono-white", "min-w-fit", "w-full"]
}else if (props.styleType === "optional"){
    classList = ["cursor-pointer", "font-bold", "text-center", "btn", "rounded-2.4xl", "xl:rounded-3xl", "text-mono-white", "bg-mono-ns-200", "hover:bg-mono-ns-300", "min-w-fit", "w-full", "relative"]
}

if (props.icon){
    classList = classList.concat(['flex', 'flex-row', 'items-center', 'justify-center', 'gap-1'])
}

function clickHandler() {
    if (props.onclick){
        const result = props.onclick()
        if (result !== undefined){
            clicked.value = result
        }
    }else{
        clicked.value = true;
    }
}
</script>

<template>
<button :class="classList" @click="clickHandler">
    <svg v-if="props.icon" class="w-4 h-4" width="24" xmlns="http://www.w3.org/2000/svg">
        <use :href="'#' + props.icon"></use>
    </svg>
    <span>{{props.label}}</span>
    <span v-if="clicked && props.spinner" class="absolute -translate-y-1/2 top-2/4 right-4">
        <span class="block border-mono-ns-200 h-4 w-4 animate-spin rounded-full border-4 border-t-mono-white"></span>
    </span>
</button>
</template>

<style scoped>

</style>
